import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
    {
        path: "/",   // path 设置为 “/” ，默认显示该页面
        component: () => import('./view/index/index'),
        name: ""
    },
    {
        name: 'checkLogin',
        component: () => import('./view/auth/checkLogin'),
    },
    {
        name: 'checkLogin2',
        component: () => import('./view/auth/checkLogin2'),
    },
    {
        name: 'checkOilLogin',
        component: () => import('./view/auth/checkOilLogin'),
    },
    {
        name: 'checkOilLogin2',
        component: () => import('./view/auth/checkOilLogin2'),
    },
];

const routesDoctor = [
    {
        name: 'main',
        component: () => import('./view/index/index'),
        meta: {
            title: ''
        }
    },
    {
        name: 'noticeInfo',
        component: () => import('./view/index/noticeInfo'),
        meta: {
            title: '通知公告'
        }
    },
    {
        name: 'prodInfo',
        component: () => import('./view/index/prodInfo'),
        meta: {
            title: '商品详情'
        }
    },
    {
        name: 'prodInfoT',
        component: () => import('./view/index/prodInfo'),
        meta: {
            title: '商品详情'
        }
    },
    {
        name: 'haibao',
        component: () => import('./view/index/haibao'),
        meta: {
            title: '商品分享'
        }
    },
    {
        name: 'haibaoShop',
        component: () => import('./view/index/haibaoShop'),
        meta: {
            title: '店铺分享'
        }
    },
    {
        name: 'userCenter',
        component: () => import('./view/account/userCenter'),
        meta: {
            keepalive:false,
            title: '个人中心'
        }
    },
    {
        name: 'account/myOrder',
        component: () => import('./view/account/myOrder'),
        meta: {
            title: '我的订单'
        }
    },
    {
        name: 'account/myOrderInfo',
        component: () => import('./view/account/myOrderInfo'),
        meta: {
            title: '订单详情'
        }
    },
    {
        name: 'manager/myOrder',
        component: () => import('./view/manager/myOrder'),
        meta: {
            title: '我的订单'
        }
    },
    {
        name: 'manager/myOrderInfo',
        component: () => import('./view/manager/myOrderInfo'),
        meta: {
            title: '订单详情'
        }
    },
    {
        name: 'account/myBalanceRecord',
        component: () => import('./view/account/myBalance'),
        meta: {
            title: '奖励记录'
        }
    },
    {
        name: 'account/myLoveRecord',
        component: () => import('./view/account/myLoveRecord'),
        meta: {
            title: '爱心记录'
        }
    },
    {
        name: 'account/wdBalance',
        component: () => import('./view/manager/wdBalance'),
        meta: {
            title: '网点收益'
        }
    },
    {
        name: 'account/departBalance',
        component: () => import('./view/manager/departBalance'),
        meta: {
            title: '店铺收益'
        }
    },
    {
        name: 'account/tgBalance',
        component: () => import('./view/manager/tgBalance'),
        meta: {
            title: '推广收益'
        }
    },
    {
        name: 'account/myLove',
        component: () => import('./view/account/myLove'),
        meta: {
            title: '我的爱心'
        }
    },
    {
        name: 'account/transferAuth',
        component: () => import('./view/account/transferAuth'),
        meta: {
            title: '开通提现授权'
        }
    },
];

for (var i = 0; i < routesDoctor.length; i++) {
    routes.push(routesDoctor[i]);
}


// add route path
routes.forEach(route => {
    route.path = route.path || '/' + (route.name || '');
});

const router = new Router({mode: 'history', routes});

router.beforeEach((to, from, next) => {
    const title = to.meta && to.meta.title;
    if (title) {
        document.title = title;
    }
    if (!to.query.mui) {
        localStorage.setItem("mui", from.query.mui)
        next({
            path: to.path,
            query: {
                ...to.query,
                mui: from.query.mui
            },
        });
    } else {
        localStorage.setItem("mui", to.query.mui)
        next();
    }
});
// 解决上面跳转加参数报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch(err => err);
};

// 修改路由replace方法,阻止重复点击报错
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err);
};
export {
    router
};
